import React, { createContext, useState, useEffect } from 'react'

const DarkModeContext = createContext()

const DarkModeProvider = (props) =>
{
    const osDarkInitial = window.matchMedia('(prefers-color-scheme: dark)').matches
    const savedTheme = localStorage.getItem('_theme') || 'auto'
    const finalTheme = (savedTheme === 'auto') ? (osDarkInitial ? 'dark' : 'light') : savedTheme
    
    const [osDark, setOsDark] = useState(osDarkInitial)
    const [theme, setThemeValue] = useState(finalTheme) // Can only contain 'dark' or 'light'
    const [isAuto, setIsAuto] = useState(savedTheme === 'auto')
    const setTheme = (newTheme) =>
    {
        localStorage.setItem('_theme', newTheme) // Stores 'dark', 'light' or 'auto'
        
        if (newTheme === 'auto')
            setThemeValue(osDark ? 'dark' : 'light')
        else
            setThemeValue(newTheme)
            
        setIsAuto(newTheme === 'auto')
    }
    
    useEffect(() =>
    {
        // Add listener to update styles
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e =>
        {
            setOsDark(e.matches)
            
            const savedTheme = localStorage.getItem('_theme') || 'auto'
            
            // If theme is set to auto -> switch theme according to device
            if (savedTheme === 'auto')
                setThemeValue(e.matches ? 'dark' : 'light')
        })

        // Remove listener
        return () => {
            window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', () => {})
        }
    }, [])
    
    
    return (
        <div className="AppTheme" data-theme={theme}>
            <DarkModeContext.Provider value={{ isAuto, darkMode: theme === 'dark', setTheme, osDark, theme }}>
                { props.children }
            </DarkModeContext.Provider>
        </div>
    )
}

export { DarkModeContext, DarkModeProvider }